import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

const line = (width: string, height: string) => ({ width, height, margin: '0' });

const ROW_SHAPES = [
  { title: '24%', badge: true, details: [line('52%', '13px'), line('30%', '13px')] },
  { title: '38%', badge: false, details: [line('38%', '13px'), line('44%', '13px')] },
  { title: '20%', badge: true, details: [line('46%', '13px'), line('26%', '13px')] },
  { title: '32%', badge: false, details: [line('30%', '13px'), line('36%', '13px')] },
  { title: '28%', badge: false, details: [line('44%', '13px'), line('32%', '13px')] },
];

@Component({
  selector: 'cipo-module-config-list-skeleton',
  templateUrl: './list-skeleton.component.html',
  imports: [NgxSkeletonLoaderModule, TranslateModule],
  host: { class: 'cipo--display--block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModuleConfigListSkeletonComponent {
  readonly label = input.required<string>();
  readonly rows = input(4);
  readonly lines = input(1);
  readonly actions = input(3);
  readonly chip = input(false);
  readonly sections = input(0);

  readonly theme = {
    title: line('100%', '18px'),
    badge: { width: '56px', height: '16px', 'border-radius': '4px', margin: '0' },
    chip: { width: '112px', height: '28px', 'border-radius': '14px', margin: '0' },
    chipType: line('96px', '13px'),
    icon: { width: '24px', height: '24px', margin: '0' },
    sectionIcon: { width: '24px', height: '24px', margin: '0' },
    sectionTitle: line('160px', '20px'),
  };

  readonly actionList = computed(() => Array.from({ length: this.actions() }, (_, index) => index));

  readonly groups = computed(() => {
    const shapes = Array.from({ length: this.rows() }, (_, index) => ({
      ...ROW_SHAPES[index % ROW_SHAPES.length],
      details: ROW_SHAPES[index % ROW_SHAPES.length].details.slice(0, this.lines()),
    }));
    const sections = this.sections();
    if (!sections) {
      return [shapes];
    }
    const perSection = Math.max(1, Math.ceil(shapes.length / sections));
    return Array.from({ length: sections }, (_, index) => shapes.slice(index * perSection, (index + 1) * perSection));
  });
}
